import React, { ReactElement, useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { buildTreeFromArrays } from '../_helper/_helper';
import { TreeNode } from '@/model/onSpot/TreeNodes';
import { OnSpotContextProps } from '@/model/onSpot/OnSpot';
import Button, { ButtonProps } from '@/comp/button/button';
import './onSpotUpload.scss';
import OverlayModal from '@/comp/overlayModal/overlayModal';
import { OnSpotContext } from '../index';
import { UploadFieldContainer } from './components/UploadFieldContainer';
import BackButton from '@/comp/backButton/backButton';

export const OnSpotUpload = () => {
    const { routes, treeSectionId, displayedQuestions, fileLists, setFileLists } = useContext(
        OnSpotContext
    ) as OnSpotContextProps;
    const [openModal, setOpenModal] = React.useState(false);
    const [countUploadSections, setCountUploadSection] = useState(0);
    const navigate = useNavigate();

    const submitButtonProps = {
        type: 'submit',
        label: 'Weiter zu den Kontaktdaten',
        validated: false,
        valid: true,
    } satisfies ButtonProps;

    const validateUploadFiles = () => {
        const uniqueUploadIds = new Set(
            Object.keys(fileLists)
                .filter((value) => fileLists[value].length)
                .map((key) => key.replace(/-(fault|general)$/, ''))
        );

        if (uniqueUploadIds.size === countUploadSections) {
            return true;
        }
        return false;
    };

    const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (!validateUploadFiles()) {
            setOpenModal(true);
        } else {
            setFileLists(fileLists);
            navigate(`/${routes?.root}/${routes?.children.contact}`, {
                state: {
                    displayedQuestions: displayedQuestions,
                    treeSectionId: 'question-2',
                },
            });
        }
    };

    const tree = (nodes: TreeNode) => {
        const elements: ReactElement<Element>[] = [];
        if (nodes) {
            if (nodes.children.length > 0) {
                nodes.children.forEach((node) => {
                    if (node.treeId !== treeSectionId) {
                        elements.push(
                            <UploadFieldContainer
                                key={`tree-${node.id}`}
                                parentTreeId={nodes.treeId}
                                category={nodes.id}
                                subCategory={node.id}
                                node={node}
                            />
                        );
                    } else if (node.children) {
                        tree(node);
                    }
                });
            } else {
                elements.push(
                    <UploadFieldContainer
                        key={`tree-${nodes.id}`}
                        parentTreeId={nodes.treeId}
                        category={nodes.id}
                        node={nodes}
                    />
                );
            }
        }

        return (
            <article key={`t-nodes${nodes.id}`}>
                <>{elements}</>
            </article>
        );
    };

    const UploadElements = () => {
        const array = Object.keys(displayedQuestions).map((key) => {
            return key;
        });
        const treeArray = buildTreeFromArrays(array);
        // should be at least 1 UploadElement
        setCountUploadSection(!treeArray?.children.length ? 1 : treeArray?.children.length);

        return (
            <section className="section-upload-step content-wrapper">
                {treeArray &&
                    (treeArray?.children?.length > 0 ? (
                        treeArray.children.map((childArray) => tree(childArray))
                    ) : (
                        <article>
                            <UploadFieldContainer
                                parentTreeId={treeArray?.treeId}
                                category={treeArray?.id}
                                node={treeArray}
                            />
                        </article>
                    ))}
            </section>
        );
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="intro row">
                    <h1 className="color-primary">Ihre Nachweise</h1>
                    <div className="intro-text">
                        <p>
                            Damit wir Ihr Anliegen schnellstmöglich bearbeiten können, ist es für uns sehr wichtig, dass
                            Sie hier vollständige und aussagekräftige Nachweise (zum Beispiel Fotos, Videos oder
                            Rechnungen) hochladen.
                        </p>
                    </div>
                </div>
            </div>
            <form>
                {displayedQuestions && treeSectionId && <UploadElements />}
                <section className="section-submit">
                    <div className="container justify-between">
                        <BackButton to={`/${routes?.root}`} label={'Zurück zum Formular'} />
                        <Button
                            type={submitButtonProps.type}
                            label={submitButtonProps.label}
                            validated={submitButtonProps.validated}
                            valid={submitButtonProps.valid}
                            handleClick={handleSubmit}
                        />
                    </div>
                </section>
            </form>
            {openModal && (
                <OverlayModal name="onSpotUpload" showLogo={true} toggleModal={() => setOpenModal(!openModal)}>
                    <div>
                        <p className="modal-title">Fehlende Nachweise</p>
                        <p className="modal-text">
                            Es scheint so als hätten Sie noch nicht bei allen Problemen einen Nachweis hochgeladen. Für
                            eine faire und nachvollziehbare Prüfung Ihres Anliegens ist mindestens ein Nachweis (z. B.
                            Foto, Beleg oder Dokument) pro Problem erforderlich.
                        </p>
                    </div>
                    <div className="modal-button-container">
                        <Button handleClick={() => setOpenModal(false)} label="Alles klar - Nachweis hinzufügen" />
                    </div>
                </OverlayModal>
            )}
        </>
    );
};
export default OnSpotUpload;
